import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail } from 'lucide-react';
import { trackCallClick, handleEmailClick } from '../utils/tracking';

const FinalCTASection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleEmailButtonClick = () => {
    trackCallClick(); // Track as conversion attempt
    handleEmailClick('info@harp-solutions.co.uk');
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Need an Engineer Fast?
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
          We're ready to respond day or night with reliable support for homes, 
          businesses, and commercial sites.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={handleEmailButtonClick}
            size="lg"
            className="bg-amber-600 hover:bg-amber-700 text-white px-10 py-6 text-lg rounded-md transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/40 flex items-center justify-center space-x-2"
          >
            <Mail className="w-5 h-5" />
            <span>Email Now</span>
          </Button>
          <Button 
            onClick={scrollToContact}
            size="lg"
            variant="outline"
            className="border-2 border-amber-600 text-amber-500 hover:bg-amber-600 hover:text-white px-10 py-6 text-lg rounded-md transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/40 flex items-center justify-center space-x-2"
          >
            <Phone className="w-5 h-5" />
            <span>Request a Quote</span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
